"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
const countries_1 = require("../../countries");
const utils_1 = require("@loadsure/utils");
const address_1 = __importDefault(require("../../address"));
const carrier_class_1 = __importDefault(require("../carrier.class"));
const carrierIdentifier_1 = __importDefault(require("../carrierIdentifier"));
const errors_1 = __importStar(require("../../errors"));
class MarineCarrier extends carrier_class_1.default {
    constructor(id, name, carrierId, email, phone, ein, address, withinLimitsOfICC, stowageDetails, registrationCountry, mmsi, vesselClass, status, pAndI, yearOfService, detentions, previousIncidents, beneficialOwner, registeredOwner, nameAndImo) {
        super(__1.eTransportMode.MARINE, id, name, email, phone, ein, address);
        this.carrierId = carrierId;
        this.withinLimitsOfICC = withinLimitsOfICC;
        this.stowageDetails = stowageDetails;
        this.registrationCountry = registrationCountry;
        this.mmsi = mmsi;
        this.vesselClass = vesselClass;
        this.status = status;
        this.pAndI = pAndI;
        this.yearOfService = yearOfService;
        this.detentions = detentions;
        this.previousIncidents = previousIncidents;
        this.beneficialOwner = beneficialOwner;
        this.registeredOwner = registeredOwner;
        this.nameAndImo = nameAndImo;
        this.stowageDetails = utils_1.getEnumKeyOrUndefined("stowageDetails", __1.eStowageDetails, stowageDetails);
    }
    static getCarrierId(data) {
        var _a;
        let carrierId = carrierIdentifier_1.default.fromObj(data === null || data === void 0 ? void 0 : data.carrierId);
        if (!carrierId || carrierId.type !== "IMO") {
            carrierId = new carrierIdentifier_1.default("IMO", (_a = data === null || data === void 0 ? void 0 : data.imo) !== null && _a !== void 0 ? _a : "");
        }
        return carrierId;
    }
    update(carrier) {
        super.update(carrier);
        this.carrierId = MarineCarrier.getCarrierId(carrier);
        this.withinLimitsOfICC = carrier.withinLimitsOfICC;
        this.registrationCountry = carrier.registrationCountry;
        this.mmsi = carrier.mmsi;
        this.vesselClass = carrier.vesselClass;
        this.status = carrier.status;
        this.pAndI = carrier.pAndI;
        this.yearOfService = carrier.yearOfService;
        this.detentions = carrier.detentions;
        this.previousIncidents = carrier.previousIncidents;
        this.beneficialOwner = carrier.beneficialOwner;
        this.registeredOwner = carrier.registeredOwner;
        this.nameAndImo = carrier.nameAndImo;
    }
    static fromObj(data) {
        return new MarineCarrier(data.id, data.name, MarineCarrier.getCarrierId(data), data.email, data.phone, data.ein, data.address ? address_1.default.fromObj(data.address) : undefined, data.withinLimitsOfICC, data.stowageDetails, data.registrationCountry, data.mmsi, data.vesselClass, data.status, data.pAndI, data.yearOfService, data.detentions, data.previousIncidents, data.beneficialOwner, data.registeredOwner);
    }
    static fromVesselService(vessel) {
        return new MarineCarrier("", vessel.name, new carrierIdentifier_1.default("IMO", vessel.imo), "", "", "", address_1.default.fromObj({
            country: vessel.flag
        }), false, undefined, countries_1.getCountryCode(vessel.flag), "", vessel.vessel_type_and_size, vessel.vessel_sanction_indicators, vessel.p_n_i_club, parseInt(vessel.built, 10), 0, 0, vessel.beneficial_owner, vessel.registered_owner, `IMO: ${vessel.imo} - ${vessel.name}`);
    }
    static empty() {
        return new MarineCarrier("", "");
    }
    get vesselName() {
        return this.name;
    }
    validate(path, isPrimary = true) {
        const errors = [];
        errors.push(...super.validate(path, isPrimary));
        if (isPrimary) {
            if (!this.carrierId ||
                this.carrierId.type !== "IMO" ||
                !this.carrierId.value) {
                errors.push(new errors_1.default(errors_1.eErrorCode.IMO_NOT_SET, `${path}.carrierId`, "IMO not set"));
            }
        }
        return errors;
    }
}
exports.default = MarineCarrier;
//# sourceMappingURL=marineCarrier.class.js.map